// src/pages/LoginPage.js
import React, { useState } from 'react';
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from '../firebase';
import { useAuth } from '../provider/AuthProvider';
import { useNavigate, Navigate} from 'react-router-dom';
import {Alert, Button, Card, Container, Form} from "react-bootstrap";
import Header from "../components/Header";

function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const { user } = useAuth();
    if (user) return <Navigate to="/charlotte" />;

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/charlotte');
        } catch (err) {
            alert("Login failed: " + err.message);
        }
    };

    return (
        <>
        <Header />
        <Container className="d-flex justify-content-center align-items-center min-vh-100">
            <Card style={{ width: '100%', maxWidth: '400px' }} className="p-4 shadow">
                <h2 className="text-center mb-4">Login</h2>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleLogin}>
                    <Form.Group controlId="formEmail" className="mb-3">
                        <Form.Label>Email address:</Form.Label>
                        <Form.Control
                            type="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group controlId="formPassword" className="mb-3">
                        <Form.Label>Password:</Form.Label>
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Button variant="primary" type="submit" className="w-100">
                        Login
                    </Button>
                    <div className="text-center mt-3">
                        <a href="/signup">Don't have an account? Sign Up</a>
                    </div>
                </Form>
            </Card>
        </Container>
        </>
    );
}

export default LoginPage;

